import styled, { css } from 'styled-components'
import colors from '../../configuration/colors'
import { H1, Caption3 } from '../styled/typography/typography'

export const PoliciesH1 = styled(H1)`
  padding: 36px 0;
`

export const TabsHeader = styled(Caption3).attrs({
  as: 'li'
})`
  display: inline-block;
  width: 25%;
  height: 42px;
  padding: 0 6px 16px;
  text-align: center;
  cursor: pointer;
  vertical-align: top;

  ${props => props.selected && css`
    border-bottom: 4px solid ${colors.oeYellow};
  `}
`
